/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchAgentMetaDto
 */
export interface SearchAgentMetaDto {
    /**
     * 
     * @type {number}
     * @memberof SearchAgentMetaDto
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SearchAgentMetaDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchAgentMetaDto
     */
    name?: string | null;
}

export function SearchAgentMetaDtoFromJSON(json: any): SearchAgentMetaDto {
    return SearchAgentMetaDtoFromJSONTyped(json, false);
}

export function SearchAgentMetaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAgentMetaDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SearchAgentMetaDtoToJSON(value?: SearchAgentMetaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'active': value.active,
        'name': value.name,
    };
}


